import { useAuthentication } from 'src/features/authentication/context';
import { Protected } from 'src/features/protected-route/components';
import { ACCOUNT_ISSUE_PATH, LOGIN_PATH, EDIT_ALARM_NOTIFICATIONS } from '../../config';
import { AppLayout } from 'src/layouts';
import {
  NAV_ITEMS_HEADER_SITES_MANAGEMENT,
  getNavItemsHeaderSiutesManagementSAAndAA,
} from 'src/features';
import { EditAlarmNotificationGroupPage } from 'src/routes/pages';
import { ElementProps } from '../../types/element';
import { LoadingElement } from '../LoadingElement';
import { AccessRoles } from 'src/features/user-account-details/types';

export const AlarmsNotificationEditElement = ({ isSuperAdmin }: ElementProps) => {
  const { isCustomerAccessAllowed, loggedIn, customerId, getCurrentRole, siteId, user } =
    useAuthentication();
  const isAccountAdmin =
    getCurrentRole(customerId.value, siteId.value) === AccessRoles.ACCOUNT_ADMIN;

  const getUniqueRedirectPath = () => {
    if (!loggedIn.value) return LOGIN_PATH;
    if (!isSuperAdmin && isCustomerAccessAllowed.value && !isAccountAdmin)
      return ACCOUNT_ISSUE_PATH + '?reason=Access Denied';
  };

  const AlarmsNotificationEditRouteElement = () => (
    <Protected
      isAuthenticated={loggedIn.value}
      isAuthorized={isSuperAdmin || (isCustomerAccessAllowed.value && isAccountAdmin)}
      uniqueRedirectPath={getUniqueRedirectPath()}
    >
      <AppLayout
        headerTitle={EDIT_ALARM_NOTIFICATIONS}
        headerNavItems={
          isSuperAdmin || isAccountAdmin
            ? getNavItemsHeaderSiutesManagementSAAndAA(user, isSuperAdmin)
            : NAV_ITEMS_HEADER_SITES_MANAGEMENT
        }
      >
        <EditAlarmNotificationGroupPage />
      </AppLayout>
    </Protected>
  );

  const getAlarmsElement = () => {
    if (!loggedIn.loaded) return <LoadingElement />;

    if (loggedIn.loaded && !loggedIn.value) return <AlarmsNotificationEditRouteElement />;

    if (!customerId.value || !customerId.loaded) return <LoadingElement />;

    if (isSuperAdmin && loggedIn.loaded) return <AlarmsNotificationEditRouteElement />;

    if (!isCustomerAccessAllowed.loaded) return <LoadingElement />;

    return <AlarmsNotificationEditRouteElement />;
  };

  return getAlarmsElement();
};
